

const initialState = {
  users: [],
  userSubscriptions: [],
  loading: false,
  error: null,
  subscriptionsType: [],
  subscriptionAssignedMessage: "",
};

const userMainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USERS_REQUEST":
    case "FETCH_USER_SUBSCRIPTIONS_REQUEST":
    case "DELETE_USER_REQUEST":
    case "CREATE_USER_SUBSCRIPTION_REQUEST":
    case "FETCH_SUBSCRIPTIONS_TYPE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_USERS_SUCCESS":
      return {
        ...state,
        users: action.payload,
        loading: false,
      };
    case "FETCH_USER_SUBSCRIPTIONS_SUCCESS":
      return {
        ...state,
        userSubscriptions: action.payload,
        loading: false,
      };
    case "DELETE_USER_SUCCESS":
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload._id),
        loading: false,
        subscriptionAssignedMessage: "User Deleted Successfully",
      };
    case "CREATE_USER_SUBSCRIPTION_SUCCESS":
      return {
        ...state,
        userSubscriptions: [...state.userSubscriptions, action.payload],
        loading: false,
        subscriptionAssignedMessage: "Saubscription has been assigned.",
      };
    case "FETCH_SUBSCRIPTIONS_TYPE_SUCCESS":
      return {
        ...state,
        subscriptionsType: action.payload,
        loading: false,
      };
    case "FETCH_USERS_FAILURE":
    case "FETCH_USER_SUBSCRIPTIONS_FAILURE":
    case "DELETE_USER_FAILURE":
    case "CREATE_USER_SUBSCRIPTION_FAILURE":
    case "FETCH_SUBSCRIPTIONS_TYPE_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default userMainReducer;
